import styled from '@emotion/styled'
export const StyleMessageContainer = styled.div`
  flex-grow: 1;
  flex: 3;
  @media (max-width: 768px) {
    flex: 1;
  }
`

export const PlaceholderWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 2rem;
  color: #6b7280;
  font-family: 'Inter', sans-serif;
  gap: 1rem;
`

export const IconWrapper = styled.div`
  background-color: #e5e7eb; // light gray background
  padding: 1rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const PlaceholderText = styled.div`
  font-size: 1.125rem;
  text-align: center;
  max-width: 300px;
  line-height: 1.6;
  opacity: 0.85;
`

export const StyleChatboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  @media (max-width: 768px) {
    transform: translateY(-7vh);
  }
`
export const StyleMessageHeader = styled.div`
  padding: 34px;
  flex: 0.6;
  @media (max-width: 768px) {
    transform: translate(-6vh, 7px);
    width: 100%;

    padding-bottom: 0;
  }
`
export const StyleMessageListWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  padding: 10px;
  flex: 5;
  height: 100%;
`
export const StyleMessageInputWrapper = styled.div`
  flex: 0.5;
  display: flex;
  align-items: center;
  position: relative;
  border-top: 1px solid ${(props: any) => props.theme.colors.borderColor};
  padding: 8px 10px;
  @media (max-width: 768px) {
    padding: 0;
  }
`
export const StyleInput = styled.textarea`
  width: 100%;
  border: none;
  outline: none;
  padding: 32px 10px 14px 65px;
  border-radius: 30px;
  resize: none;
  overflow-y: auto;
  &::placeholder {
    color: ${(props: any) => props.theme.colors.placeholder};
  }
`

export const UploadInput = styled.input`
  display: none;
`

export const GalleryIconWrapper = styled.label`
  cursor: pointer;
  position: absolute;
  left: 1.2rem;
  top: 55%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
`
export const SendIconWrapper = styled.div`
  cursor: pointer;
  position: absolute;
  right: 1.2rem;
  top: 55%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 300ms linear;
  &:hover {
    scale: 1.08;
  }
  &:active {
    scale: 0.97;
  }
`
